import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './create-short-url-in-appsflyer_types.2';

export function createShortUrlInAppsflyer(variable: types.CreateShortUrlInAppsflyerVariables, options?: GqlRequestOptions) {
  const query = 'mutation CreateShortUrlInAppsflyer($deep_link: String!) { createShortUrlInAppsflyer(deep_link: $deep_link) { short_url } }';
  return gql_request<types.CreateShortUrlInAppsflyer, types.CreateShortUrlInAppsflyerVariables>('CreateShortUrlInAppsflyer', query, variable, { use_consumer: true, ...options });
}

